import { render } from "./TableMetric.vue?vue&type=template&id=5dd3c2a4"
import script from "./TableMetric.vue?vue&type=script&lang=js"
export * from "./TableMetric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TableMetric.vue"]])

export default __exports__